import { render, staticRenderFns } from "./AddMachineBooking.vue?vue&type=template&id=505b906c&"
import script from "./AddMachineBooking.vue?vue&type=script&lang=js&"
export * from "./AddMachineBooking.vue?vue&type=script&lang=js&"
import style0 from "./AddMachineBooking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports